import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import '@application/utilities/i18n';
import CustomThemeProvider from '@ui/theme';
import App from './App';
import { Provider } from 'react-redux';
import { store } from '@application/store';
import { EventType, PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './auth-config';
import LocalStorageService from '@application/common/local-storage-service';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import './index.css';
import 'react-quill/dist/quill.snow.css';
// Set default locale to en-GB for consistent DD/MM/YYYY formatting
dayjs.locale('en-gb');
const container = document.getElementById('root') ?? document.createElement('root');
const root = createRoot(container);
export const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.initialize().then(() => {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length) {
        msalInstance.setActiveAccount(accounts[0]);
    }
    msalInstance.addEventCallback((event) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
            const paylaod = event.payload;
            const account = paylaod.account;
            msalInstance.setActiveAccount(account);
        }
        else if (event.eventType === EventType.LOGOUT_SUCCESS) {
            LocalStorageService.removeAccessToken();
        }
    });
});
root.render(
// <React.StrictMode>
_jsx(Provider, { store: store, children: _jsx(MsalProvider, { instance: msalInstance, children: _jsx(LocalizationProvider, { dateAdapter: AdapterDayjs, children: _jsx(CustomThemeProvider, { children: _jsx(App, {}) }) }) }) })
// </React.StrictMode>
);
